import { SCREENTABS_VALIDATION_ERROR } from './constants';
import type { ScreenTabsValidationError } from './types';

export const toScreenTabsValidationError = (message: string): ScreenTabsValidationError => ({
	message,
	type: SCREENTABS_VALIDATION_ERROR,
});
